import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import { MessageService } from 'primeng/api';
import { ArchivosPersonalizados } from 'src/app/interfaces/archivoPersonalizadoData';
import { LoginService } from 'src/app/service/login.service';
import { MensajesService } from 'src/app/service/message.service';

@Component({
  selector: 'app-archivo-personalizado-grupo',
  templateUrl: './archivo-personalizado-grupo.component.html',
  styleUrls: ['./archivo-personalizado-grupo.component.scss'],
  providers: [MessageService]
})
export class ArchivoPersonalizadoGrupoComponent implements OnInit{
  deviceUrl: string = '';
  deviceName: string = '';

  camposMensaje: ArchivosPersonalizados = {
    idCustomer: 0,
    token: '',
    nombreCampania: '',
    textoimagen: '',
    verificarNumeros: 'No',
    nombrearchivo: ''
  }

  validar: boolean = false;

  archivoSeleccionado: File | null = null;

  importacionCsvSeleccionada: boolean = true;

  constructor(private mensajesService: MensajesService, private messageService: MessageService, private route: ActivatedRoute,
    private loginService: LoginService, private router: Router, private translate: TranslateService){
      // Establecer idiomas disponibles y el idioma por defecto
      translate.addLangs(['en', 'es']);
      translate.setDefaultLang('es');
    }

    ngOnInit(): void {
      this.route.queryParams.subscribe(params => {
        const token = params['deviceUrl'] || '';
        const nombre = params['deviceName'] || '';
        if (token) {
          this.deviceUrl = token;
        } 
        if(nombre){
          this.deviceName = nombre;
        }
      });
      this.camposMensaje.idCustomer = this.loginService.chatCrmUser.idCustomer;     
       // Obtener el parámetro 'lang' de la URL
      this.route.queryParams.subscribe(params => {
        const lang = params['lang'];
        if (lang) {
          this.translate.use(lang);
        } else {
          this.translate.use('es'); // Idioma por defecto
        }
      });     
    }

    // Método para manejar la selección de archivos
  onFileSelected(event: any) {
    const fileList: FileList = event.target.files;
    if (fileList.length > 0) {
      this.archivoSeleccionado = fileList[0];
    }
  }

  enviarArchivo(): void{
    if(this.camposMensaje.nombreCampania === "" || this.camposMensaje.nombrearchivo === "" ||  this.camposMensaje.textoimagen === ""){
        this.messageService.add({severity: 'error', summary: 'Error', detail: this.translate.instant('ALERT_FIELDS')})
        this.validar = true;
        return;    
      }

      if (!this.deviceUrl) {
        this.messageService.add({
          severity: 'error', 
          summary: 'Error', 
          detail: this.translate.instant('SELECT_DEVICE_ERROR')
        });
        return;
      }
      this.camposMensaje.token = this.deviceUrl;
      if (this.archivoSeleccionado) {
        console.log("Archivo seleccionado:", this.archivoSeleccionado);
      // Llama al servicio para crear la lista, pasando la nuevaLista y el archivoSeleccionado
      this.mensajesService.enviarArchivoPersonalizado(this.camposMensaje, this.archivoSeleccionado)
      .subscribe(() => {
        this.messageService.add({ severity: 'success', summary: 'Éxito', detail: this.translate.instant('PERSONALIZED_FILE')});
        setTimeout(()=>{this.router.navigate(['/campaigns'], {queryParams: {deviceUrl: this.deviceUrl, deviceName: this.deviceName},
        queryParamsHandling: 'merge' })},2500)
      }, () => {
        this.messageService.add({ severity: 'error', summary: 'Error', detail: this.translate.instant('FILE_ERROR')});
      });
      }
  }

  regresar(deviceUrl: string, deviceName: string){
    this.router.navigate(['/campaigns'], { queryParams: { deviceUrl: this.deviceUrl, deviceName: this.deviceName }, 
    queryParamsHandling: 'merge' });
  }

}
